import type { CSSProperties } from 'react';

import classNames from 'classnames';

import { getWidthStyle } from '../utils/sizing';

import * as styles from './Blockquote.css';
import type { BlockquoteElementProps, QuoteCaptionElementProps, QuoteElementProps } from './Blockquote.types';

export function QuoteElement(props: QuoteElementProps) {
  const { children } = props;

  return <blockquote className={styles.blockquote}>{children}</blockquote>;
}

export function CaptionElement(props: QuoteCaptionElementProps) {
  const { children } = props;
  return (
    <div>
      <small>{children}</small>
    </div>
  );
}

export function BlockquoteElement(props: BlockquoteElementProps) {
  const { element, children, attributes, className } = props;
  const { width, width_max, customAttributes } = element.attrs || {};

  return (
    <div
      {...customAttributes}
      className={classNames(className, styles.blockquoteElement, customAttributes?.className)}
      style={
        {
          '--width': getWidthStyle(width, width_max).width,
          '--max-width': getWidthStyle(width, width_max).maxWidth,
        } as CSSProperties
      }
      {...attributes}
    >
      {children}
    </div>
  );
}
